<template>
    <div class="bigDiv">
        <div class="h-crumbOut">
            <div class="h-crumbs">
                <el-breadcrumb separator="|">
                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item><a href="/">项目管理</a></el-breadcrumb-item>
                    <el-breadcrumb-item><a href="/">盈利测算</a></el-breadcrumb-item>
                </el-breadcrumb>
            </div>    
        </div>
        <div class="h-piece">
            <div class="h-pieceIn2">
                <div class="h-pieceTitle2">
                    <h1>项目信息</h1>
                </div>
                <div class="h-pieceCon2">
                    <div class="h-formLine yingli">
                        <el-form :model="formLabelAlign" label-position="right"  :inline="true"  class="demo-ruleForm h-formbLine">
                        <el-form-item label="项目名称" class="h-elformWrap-2" >
                            <el-input v-model="formLabelAlign.contactInfo" placeholder="自带出"></el-input>
                        </el-form-item>
                        <el-form-item label="投标方式" class="h-elformWrap-2" >
                            <el-input v-model="formLabelAlign.contactInfo" placeholder="请选择"></el-input>
                        </el-form-item>
                       <el-form-item label="开标日期" class="h-elformWrap-2">
                            <el-select v-model="formLabelAlign.type" placeholder="请选择">
                                <el-option label="类型一" value="type1"></el-option>
                                <el-option label="类型二" value="type2"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="保修期" class="h-elformWrap-2">
                            <el-select v-model="formLabelAlign.type" placeholder="请选择">
                                <el-option label="类型一" value="type1"></el-option>
                                <el-option label="类型二" value="type2"></el-option>
                            </el-select>
                        </el-form-item>
                        <br>
                        <el-form-item label="付款方式" class="h-elformWrap-1">
                            <el-input class="input" v-model="formLabelAlign.contactInfo" placeholder="请输入   %(预付)" style="margin-top:-20px;"></el-input>
                            <el-input class="input" v-model="formLabelAlign.contactInfo" placeholder="请输入   %(首款)" ></el-input>
                            <el-input class="input3" v-model="formLabelAlign.contactInfo" placeholder="请输入   %(中款)"></el-input>
                            <el-input class="input4" v-model="formLabelAlign.contactInfo" placeholder="请输入   %(尾款)"></el-input>
                        </el-form-item>
                        <br>
                        <div style=" ">
                            <el-form-item label="账期" class="h-elformWrap-1" >
                            <el-input  placeholder="请输入   天(预付)" ></el-input>
                            <el-input  placeholder="请输入   天(预付)" ></el-input>
                            <el-input  placeholder="请输入   天(预付)" ></el-input>
                            <el-input  placeholder="请输入   %(预付)" ></el-input>
                        </el-form-item>
                        </div>
                        <br>
                       <el-form-item label="项目背景" class="h-elformWrap-1">
                            <el-input v-model="formLabelAlign.contactInfo" placeholder="请输入" style="margin-bottom:15px;"></el-input>
                        </el-form-item>
                        <br>
                        <el-form-item label="终端成交" class="h-elformWrap-2">
                            <el-select v-model="formLabelAlign.type" placeholder="请选择">
                                <el-option label="类型一" value="type1"></el-option>
                                <el-option label="类型二" value="type2"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="专营商毛利率" class="h-elformWrap-2" >
                            <el-input v-model="formLabelAlign.contactInfo" placeholder="公式计算"></el-input>
                        </el-form-item>
                        </el-form>
                    </div>
                </div>
                </div>
            </div>
        <div class="h-table" style=" margin: 20px 20px">
        <el-table
            :data="tableData"
            :span-method="objectSpanMethod"
            border
            >
            <el-table-column
            prop="message"
            label="分类"
            width="180">
        </el-table-column>
        <el-table-column
            prop="coding"
			:show-overflow-tooltip="true"
            label="科目">
        </el-table-column>
        <el-table-column
            prop="shuoming"
			:show-overflow-tooltip="true"
            label="说明">
        </el-table-column>
        <el-table-column
            prop="biaozhun"
            label="标准/单台">
        </el-table-column>
        <el-table-column
            prop="hejiL"
            label="合计-率">
        </el-table-column>
        <el-table-column
            prop="hejiE"
            label="合计-额">
        </el-table-column>
        <el-table-column
            prop="xinghao"
            label="型号">
        </el-table-column>
    </el-table>
    </div>
    <div>
    <div class="drags" style="width:96.43%; height:60px;padding:10px 38px;margin-left:21px;margin-top:-20px;line-height:60px;">
        <el-slider v-model="value3" :show-tooltip="false"></el-slider>
    </div>
    </div>
    <div class="enter">
        <el-form :model="formLabelAlign"   :inline="true"  class="demo-ruleForm h-formbLine">
            <el-form-item label="订单总收入(不含税)" class="h-elformWrap-2" style="margin-left:33px; margin-top:10px">
                <el-input  v-model="formLabelAlign.contactInfo" placeholder="公式计算" style="width:5rem;"></el-input>
            </el-form-item>
            <el-form-item label="盈亏平衡(含税价)" class="h-elformWrap-2" style="margin-left:8rem; margin-top:-0.9rem;">
                <el-input  v-model="formLabelAlign.contactInfo" placeholder="公式计算" style="width:5rem;"></el-input>
            </el-form-item>
            <el-form-item label="超低温" class="h-elformWrap-1" style="margin-left:14px;">
                <el-input  v-model="formLabelAlign.contactInfo" placeholder="公式计算" style="width:162px;"></el-input>
                <el-input  v-model="formLabelAlign.contactInfo" placeholder="公式计算" style="width:162px; margin-left:28px;"></el-input>
            </el-form-item>
            <el-form-item label="生物安全" class="h-elformWrap-1" style="margin-left:542px;margin-top:-45px;">
                <el-input  v-model="formLabelAlign.contactInfo" placeholder="公式计算" style="width:162px;"></el-input>
                <el-input  v-model="formLabelAlign.contactInfo" placeholder="公式计算" style="width:162px; margin-left:28px;"></el-input>

            </el-form-item>
            <el-form-item label="疫苗网" class="h-elformWrap-1" style="margin-left:14px;">
                <el-input  v-model="formLabelAlign.contactInfo" placeholder="公式计算" style="width:162px;"></el-input>
                <el-input  v-model="formLabelAlign.contactInfo" placeholder="公式计算" style="width:162px; margin-left:28px;"></el-input>
            </el-form-item>
            <el-form-item label="培养箱" class="h-elformWrap-2" style="margin-left:562px;margin-top:-45px;">
                <el-input  v-model="formLabelAlign.contactInfo" placeholder="公式计算" style="width:162px;"></el-input>
                <el-input  v-model="formLabelAlign.contactInfo" placeholder="公式计算" style="width:162px; margin-left:28px;"></el-input>
            </el-form-item>
        </el-form>
    </div>
    <div>
        
    </div>
     <div class="xia">
        <el-row>
			<el-button class="h-btn h-bBtn h-bgwhite">返回</el-button>
			<el-button class=" h-btn h-bBtn h-bggreen" >暂存</el-button>
			<el-button class="h-btn h-bBtn h-bgblueQ2">确认提交</el-button>
        </el-row>
      </div>
    </div>
</template>
<style scoped>
    .xia{
        margin-left: 400px;
        margin-top: 60px;
    }
    .zancun{
        background-color: #24b5b8;
        color: white;
    }
    .enter{
        /* width:1138px;
        margin-left: 21px; */
    
        margin: -30px 21px 0 21px;
        background-color: #fff;
        height: 2.5rem;
    }
    .bigDiv .h-piece{
        margin:0 20px;
    }
    .h-crumbOut{
        margin-bottom: 20px;
    }
    .drags{
    background-color: #ffffff;
    margin-bottom: 30px;
    }
   
</style>
<style>
.drags .el-slider__button-wrapper .el-slider__button{
    background: url(../../../assets/images/drag.png) center/cover;
    border: 0;
    border-radius: 0;
    width: 20px;
    height: 20px;
}
.yingli .h-formbLine .el-form-item__label{
    width: 36%;
}
.yingli .h-formbLine .el-form-item__content{
    width: 64%;
}
.yingli .h-formbLine .h-elformWrap-2{
    width: 32%;
}

.yingli .h-formbLine .h-elformWrap-1 .el-form-item__content{
    width: 36%;
}
.yingli .h-formbLine .h-elformWrap-1 .el-form-item__label{
    width: 19%;
}
.yingli .h-formbLine .h-elformWrap-1{
    width:53%;
}
</style>

<script>
export default {
    data(){   
        return{
            value3:36,
            //   横向的相关数据
            tableData: [{
                message: '基本信息',
                coding: '编码',
                shuoming:'-',
                biaozhun: '-',
                hejiL: '-',
                hejiE:'-',
                xinghao:'BEOFOEO1T'
            }, 
            {
                coding: '型号',
                biaozhun: '-',
                shuoming:'-',
                hejiL: '-',
                hejiE:'-',
                xinghao:'DW-86L828J',
            }, 
            {
                coding: '产品大类',
                biaozhun: '-',
                shuoming:'-',
                hejiL: '-',
                hejiE:'-',
                xinghao:'超低温',
            }, 
            {
                coding: '产品系列',
                biaozhun: '-',
                shuoming:'-',
                hejiL: '-',
                hejiE:'-',
                xinghao:'-86℃低温保存箱',
            }, 
            {
                message: '收入',
                coding: '单台一级供价',
                biaozhun: '-',
                shuoming:'-',
                hejiL: '-',
                hejiE:'51,000',
                xinghao:'51,000',
            },
            {
                coding: '折扣率',
                biaozhun: '-',
                shuoming:'-',
                hejiL: '51%',
                hejiE:'51%',
                xinghao:'51%',
            },
            {
                coding: '销量',
                biaozhun: '-',
                shuoming:'-',
                hejiL: '-',
                hejiE:'5',
                xinghao:'5|',
            },
            {
                coding: '申请单价(含税)',
                biaozhun: '-',
                shuoming:'-',
                hejiL: '-',
                hejiE:'26,000',
                xinghao:'26,000',
            },
            {
                coding: '订单金额',
                biaozhun: '-',
                shuoming:'-',
                hejiL: '-',
                hejiE:'130,000',
                xinghao:'130,000',
            },
            {
                coding: '不含税订单收入',
                biaozhun: '-',
                shuoming:'-',
                hejiL: '-',
                hejiE:'115.044',
                xinghao:'115.044'
            },
            {
                coding: '盈亏平衡含税价',
                biaozhun: '-',
                shuoming:'-',
                hejiL: '-',
                hejiE:'115.044',
                xinghao:'115.044'
            },
            {
                message: '盈利情况',
                coding: '材料毛利',
                shuoming:'-',
                biaozhun: '-',
                hejiL: '-',
                hejiE:'115.044',
                xinghao:'115.044'
            },
            {
                coding: '经营贡献',
                biaozhun: '-',
                shuoming:'-',
                hejiL: '-',
                hejiE:'115.044',
                xinghao:'115.044'
            },
            {
                coding: '利润',
                biaozhun: '-',
                shuoming:'-',
                hejiL: '-',
                hejiE:'115.044',
                xinghao:'115.044'
            },
            {
                message:'毛利',
                coding: '单台成本',
                shuoming:'测算当月BOM成本',
                biaozhun: '-',
                hejiL: '-',
                hejiE:'115.044',
                xinghao:'115.044'
            },
            {
                coding: '成本合计',
                biaozhun: '-',
                shuoming:'-',
                hejiL: '-',
                hejiE:'115.044',
                xinghao:'115.044'
            },
            {
                coding: '毛利',
                biaozhun: '-',
                shuoming:'-',
                hejiL: '-',
                hejiE:'115.044',
                xinghao:'115.044'
            },
            {
                coding: '材料毛利率',
                biaozhun: '-',
                hejiL: '-',
                shuoming:'-',
                hejiE:'115.044',
                xinghao:'115.044'
            }
            ,
            {
                message:'直接费用',
                coding: '附加成本',
                biaozhun: '-',
                shuoming:'-',
                hejiL: '-',
                hejiE:'115.044',
                xinghao:'115.044'
            },
            {
                coding: '中标服务费',
                biaozhun: '-',
                shuoming:'-',
                hejiL: '-',
                hejiE:'115.044',
                xinghao:'115.044'
            }],
            formLabelAlign: {
                name: '',
                contact:'',
                contactInfo:'',
                type: '',
                date3: '',
                explain:''
            },
        };
    },
   
    methods: {
      arraySpanMethod({ row, column, rowIndex, columnIndex }) {
        if (rowIndex % 3 === 0) {
            if (columnIndex === 0) {
                return [1, 4];
            } else if (columnIndex === 1) {
                return [0, 0];
            }
        }
      },

      objectSpanMethod({ row, column, rowIndex, columnIndex }) {
        if (columnIndex === 0) {
            if (rowIndex === 0) {
                return {
                rowspan: 4,
                colspan: 1
                };
            }else if (rowIndex === 4) {  // 当第7行就为正常的一行；要返回 把1行合并为一列
                return {
                    rowspan: 7,
                    colspan: 1
                };
            } else if(rowIndex === 11){
                return {
                    rowspan: 3,
                    colspan: 1
                }
            }else if(rowIndex === 14){
                return {
                    rowspan: 4,
                    colspan: 1
                }
            }else if(rowIndex === 18){
                    return {
                    rowspan: 2,
                    colspan: 1
                    }
            }else{
                return {
                    rowspan: 0,
                    colspan: 0
                }
            }
        }
        if(columnIndex === 1){
            if (rowIndex === 19) {
                return {
                rowspan: 2,
                colspan: 1
                };
            }else if(rowIndex === 21){
                return {
                rowspan: 2,
                colspan: 1
                };
            }else if(rowIndex === 28){
                return {
                rowspan: 2,
                colspan: 1
                };
            }else if(rowIndex === 30){
                return {
                rowspan: 2,
                colspan: 1
                };
            }else if(rowIndex === 32){
                return {
                rowspan: 2,
                colspan: 1
                };
            }else{
                return {
                    rowspan: 1,
                    colspan: 1
                }
            }
            }; 
      },
        
        // rules: {
        //     name: [
        //     { required: true, message: '请输入项目名称', trigger: 'blur' },
        //     ],
        // }
      }
    }

</script>


